module.exports = require("!!vue-loader!./../../node_modules/vue-markdown-loader/_cache/sample-2.vue");


//////////////////
// WEBPACK FOOTER
// ./docs/examples/sample.md
// module id = 226
// module chunks = 0